import React, { ReactElement, useEffect, useState } from 'react';
import './KodanshaSelectMenu.scss';
import MenuArrow from '../../Assets/icons/MenuArrow';

interface KodanshaSelectMenuProps {
    title: string;
    items: string[] | number[] | undefined;
    onItemSelected?: (...args) => any;
}

const KodanshaSelectMenu = ({ title, items, onItemSelected }: KodanshaSelectMenuProps): ReactElement => {
    const [active, setActive] = useState(false);

    useEffect(() => {
        const close = () => {
            setActive(false);
        };
        if (active) {
            window.addEventListener('click', close);
        }
        return () => window.removeEventListener('click', close);
    }, [active]);

    return (
        <div onClick={() => setActive(active => !active)} className='ui-select-menu-container'>
            <div className='header-wrapper'>
                <span className='ui-select-menu-title'>{title}</span>
                <MenuArrow />
            </div>

            {active &&
                <div className='ui-select-menu-open-wrapper'>
                    {items?.map((item, index) => {
                        return <div key={item + index}
                                    onClick={() => onItemSelected && onItemSelected(index)}
                                    className='ui-select-menu-item'>
                            {item}
                        </div>;
                    })}
                </div>
            }

        </div>
    );
};

export default KodanshaSelectMenu;